import {
  formatToCurrencyTypeFloor,
  formatToCurrencyTypeToFixed,
} from "helper/common";
import React from "react";
import {CURRENCY_LOCALE} from "types/enums";
import {ColumnProps} from "types/models";
const columns: ColumnProps[] = [
  {
    title: "STT",
    dataIndex: "STT",
    show: true,
    render(value, record, index) {
      return <div>{index + 1}</div>;
    },
    align: "center",
  },
  {title: "Mã kính", dataIndex: "code", show: true, align: "left"},
  {title: "Tên kính", dataIndex: "glassesName", show: true, align: "left"},

  {title: "Số lượng", dataIndex: "soLuong", show: true, align: "right"},
  {
    title: "Đơn giá",
    dataIndex: "donGia",
    show: true,
    align: "right",
    render(value, record, index) {
      return (
        <>{formatToCurrencyTypeToFixed(value, 0, CURRENCY_LOCALE.TYPE_DE)}</>
      );
    },
  },
  {title: "VAT", dataIndex: "vat", show: true, align: "right"},
  {
    title: "Thành tiền",
    dataIndex: "thanhTien",
    show: true,
    align: "right",
    render(value, record, index) {
      return (
        <>{formatToCurrencyTypeToFixed(value, 0, CURRENCY_LOCALE.TYPE_DE)}</>
      );
    },
  },
  {
    title: "Miễn giảm",
    dataIndex: "giamGia",
    show: true,
    align: "right",
    render(value, record, index) {
      return (
        <>{formatToCurrencyTypeToFixed(value, 0, CURRENCY_LOCALE.TYPE_DE)}</>
      );
    },
  },
];
export {columns};
